export default [
	{
		code: 'owner',
		name: 'Owner',
	},
	{
		code: 'admin',
		name: 'Admin',
	},
	{
		code: 'super user',
		name: 'Super User',
	},
	{
		code: 'senior agent',
		name: 'Senior Agent',
	},
	{
		code: 'agent',
		name: 'Agent',
	},	
	{
		code: 'intern',
		name: 'Intern',
	},	
	{
		code: 'external',
		name: 'External',
	},	
];